module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1d1b3c38a9abf54cc65.worker.js");
};